import { render, staticRenderFns } from "./MdSection.vue?vue&type=template&id=3f462811&scoped=true&"
import script from "./MdSection.vue?vue&type=script&lang=js&"
export * from "./MdSection.vue?vue&type=script&lang=js&"
import style0 from "./MdSection.vue?vue&type=style&index=0&id=3f462811&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f462811",
  null
  
)

export default component.exports